import { useEffect, useState } from "react";
import { useFounding } from "@/hooks/useFounding";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import SleepScale from "@/components/SleepScale";
import BeliefsDeck from "@/components/BeliefsDeck";
import ExplainSection from "@/components/ExplainSection";
import FoundingGrid from "@/components/FoundingGrid";
import WaitlistForm from "@/components/WaitlistForm";
import Footer from "@/components/Footer";

export default function Home() {
  const { taken, cap, total } = useFounding();
  const [sleepRating, setSleepRating] = useState(null);

  useEffect(() => {
    if (window.location.hash === "#waitlist") {
      const t = setTimeout(() => {
        document.getElementById("waitlist")?.scrollIntoView({ behavior: "smooth" });
      }, 400);
      return () => clearTimeout(t);
    }
  }, []);

  return (
    <div data-testid="home-page" className="relative min-h-screen text-[#171512]">
      <Navbar taken={taken} cap={cap} />
      <main>
        <Hero total={total} />
        <Marquee />
        <SleepScale value={sleepRating} onChange={setSleepRating} />
        <BeliefsDeck />
        <ExplainSection />
        <FoundingGrid taken={taken} cap={cap} />
        <WaitlistForm taken={taken} cap={cap} sleepRating={sleepRating} />
      </main>
      <Footer />
    </div>
  );
}
